import CloseIcon from '@mui/icons-material/Close';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Divider,
  Paper
} from '@mui/material';
import { DatePicker, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Confirm } from 'src/components/common/Confirm';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { SERVER_DATE_FORMAT, UI_TIME_ZONE } from 'src/constants/formats';
import { archLevel } from 'src/data/config';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useIssueLog } from '../IssueLog/useIssueLog';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useProtocolDeviationsLog } from '../ProtocolDeviationslLog/useProtocolDeviationsLog';
import '../StudyLogs.scss';
import { useIMVFollowUpVisit } from './useIMVFollowUp';
import { MainRTE } from '@pihealth/common-ui-library';
import StaticJson from '../../../../resources/static.json';

interface IFollowUPLetterProps {
  setOpenFollowupLetter: (openfl: boolean) => void;
  setViewIMVFollowUpGrid: (viewflGrid: boolean) => void;
  letterData: any;
  setLettersListBackOn: (lettersListOn: boolean) => void;
  isChanged: boolean;
  setIsChanged: (isChanged: boolean) => void;
  openConfirmExit: boolean;
  setOpenConfirmExit: (isOpenConfirm: boolean) => void;
  siteStudyPersonnelsData: any;
  handleBack: (isFormChanged: boolean) => void;
  originalReviewedItems: any;
}

const IMVFollowupLetter = (props: IFollowUPLetterProps) => {
  const { checkPermission } = usePermissionWrapper();
  const updateFULetterPermission = checkPermission('update_imv_followupletter');
  const publishFULetterPermission = checkPermission('publish_imv_followupletter');
  const dispatch = useAppDispatch();
  const { userPreferedDateFormat, getPreferredDateInLocal, getServerDateOrInvalidDayJs, preferedFormatForDatePicker } =
    usePreferedDateFormat();
  const { user: userFullName } = useUser();
  const [reviewCodelistItems, setReviewCodelistItems] = useState<any>([]);

  const [openConfirmRemove, setOpenConfirmRemove] = useState(false);
  const [removingReviewItem, setRemovingReviewItem] = useState({
    item: '',
    index: 0
  });
  const [reviewedItems, setReviewedItems] = useState<string[]>([]);
  const [isLetterCreated, setIsLetterCreated] = useState(false);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const email = useAppSelector(state => state.user.user?.email);
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const contentEditPermission = checkPermission('edit_imv_followup_letter');
  const [openRTE1, setOpenRTE1] = useState(false);
  const [openRTEContent1, setOpenRTEContent1] = useState(false);
  const [openRTE2, setOpenRTE2] = useState(false);
  const [openRTEContent2, setOpenRTEContent2] = useState(false);
  const [htmlContent1, setHtmlContent1] = useState('');
  const [htmlContent2, setHtmlContent2] = useState('');
  const [disableEditContent1, setDisableEditContent1] = useState(false);
  const [disableEditContent2, setDisableEditContent2] = useState(false);
  const { unSavedWarning } = useFieldTranslation();

  const phoneNumberLetter = props.siteStudyPersonnelsData?.personnel
    .map((items: { site_per_email: string | undefined; site_per_phone: any }) => {
      if (items.site_per_email?.toLowerCase() === email?.toLowerCase()) {
        return items.site_per_phone;
      }
    })
    .filter((item: any) => {
      if (item !== undefined) {
        return item;
      }
    });
  const initFollowUpLetter = {
    visit_follow_up: {
      stdy_imvfl_salutation_letter: '',
      stdy_imvfl_phone_number_letter: phoneNumberLetter[0],
      stdy_imvfl_email_address: email,
      stdy_imvfl_cra_first_name: userFullName,
      stdy_imvfl_name_sponsor: '',
      stdy_imvfl_publish_version: 0,
      stdy_imvfl_next_visit_date: '',
      stdy_imvfl_review_items: '',
      tp_document_meta_id: '',
      tp_document_id: '',
      monitoring_visit_id: props.letterData.id,
      is_published: true,
      imvfl_rte1: '',
      imvfl_rte2: '',
      id: '',
      stdy_imvfl_visit_issue: '',
      stdy_imvfl_visit_start_date: '',
      stdy_imvfl_visit_end_date: '',
      stdy_imvfl_visit_protocol_deviation: '',
      stdy_imvfl_visit_start_date_protocol_deviation: '',
      stdy_imvfl_visit_end_date_protocol_deviation: ''
    },
    protocol_deviations: [],
    issues: []
  };
  const [imvFollowUpData, setIMVFollowUpData] = useState(initFollowUpLetter);
  const [openImport, setOpenImport] = useState(false);
  const dateFormat = userPreferedDateFormat.toUpperCase();
  const [logType, setLogType] = useState('');
  const [imvFLdetailsError, setIMVFLdetailsError] = useState<any>({
    stdy_imvfl_visit_start_date: null,
    stdy_imvfl_visit_end_date: null,
    stdy_imvfl_visit_start_date_protocol_deviation: null,
    stdy_imvfl_visit_end_date_protocol_deviation: null
  });
  useEffect(() => {
    if (props.isChanged) {
      setConfirmExitValue(dispatch, true);
    }
  }, [props.isChanged]);

  const {
    getimvFollowUpData,
    createImvFollowUpIsError,
    createImvFollowUpIsSuccess,
    createImvFollowUp,
    updateImvFollowUpIsError,
    updateImvFollowUpIsSuccess,
    updateImvFollowUp,
    publishImvFollowUpError,
    publishImvFollowUpIsSuccess,
    publishImvFollowUpData
  } = useIMVFollowUpVisit();
  const getIndividualFollowUp = async () => {
    dispatch(showLoader());
    const followupResult: any = await getimvFollowUpData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      monitoring_visit_id: imvFollowUpData.visit_follow_up.monitoring_visit_id
    });
    if (followupResult?.isSuccess) {
      setIsLetterCreated(true);
      const savedReviewedItems = followupResult?.data.visit_follow_up.stdy_imvfl_review_items
        ? followupResult?.data.visit_follow_up.stdy_imvfl_review_items.split('|')
        : [];
      let imvReviewList = [];
      if (savedReviewedItems.length > 0) {
        imvReviewList =
          props.originalReviewedItems.length &&
          props.originalReviewedItems.filter(
            (reviewItem: any) => !savedReviewedItems.includes(reviewItem.code_list_value)
          );
      } else {
        imvReviewList = props.originalReviewedItems ? props.originalReviewedItems : [];
      }
      setReviewedItems(savedReviewedItems);
      setIMVFLReviewItems(savedReviewedItems);
      setReviewCodelistItems(imvReviewList);
      setIMVFollowUpData(followupResult?.data);
    } else if (followupResult?.isError) {
      setReviewedItems([]);
      setIMVFLReviewItems([]);
      setIsLetterCreated(false);
      if (followupResult?.error?.status === 404) {
        setIMVFollowUpData({
          ...initFollowUpLetter,
          visit_follow_up: { ...initFollowUpLetter.visit_follow_up }
        });
      } else {
        setIMVFollowUpData(initFollowUpLetter);
      }
      if (followupResult?.error?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (followupResult?.error?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    dispatch(hideLoader());
  };

  const handleChange = (e: any) => {
    props.setIsChanged(true);
    setIMVFollowUpData({
      ...imvFollowUpData,
      visit_follow_up: { ...imvFollowUpData.visit_follow_up, [e.target.name]: e.target.value.trimStart() }
    });
    setValidationObj({ ...validationObj, [e.target.name]: false });
  };
  const { getProtocolDeviationLogBasedOnDateRange } = useProtocolDeviationsLog();
  const { getIssueLogBasedOnDateRange } = useIssueLog();

  const onReviewItemClose = (reviewedItem: string, reviewItemIndex: number) => {
    setOpenConfirmRemove(true);
    setRemovingReviewItem({
      item: reviewedItem,
      index: reviewItemIndex
    });
  };
  const handleReviewItemClose = () => {
    props.setIsChanged(true);
    setOpenConfirmRemove(false);
    const updatedReviewedItems = reviewedItems.filter((_: string, index: number) => index !== removingReviewItem.index);
    setReviewedItems(updatedReviewedItems);
    const removedReviewCodelistitem = props.originalReviewedItems.find(
      (reviewItem: any) => reviewItem.code_list_value === removingReviewItem.item
    );
    setIMVFLReviewItems(updatedReviewedItems);
    setReviewCodelistItems(
      [...reviewCodelistItems, removedReviewCodelistitem].sort((a, b) => {
        return Number(b.code_list_value_code) - Number(a.code_list_value_code);
      })
    );
  };

  const setIMVFLReviewItems = (itemsArray: string[]) => {
    setIMVFollowUpData({
      ...imvFollowUpData,
      visit_follow_up: {
        ...imvFollowUpData.visit_follow_up,
        stdy_imvfl_review_items: itemsArray.length > 0 ? itemsArray.join('|') : ''
      }
    });
  };

  const initialMandatoryValidation = {
    stdy_imvfl_salutation_letter: false,
    stdy_imvfl_next_visit_date: false,
    stdy_imvfl_phone_number_letter: false,
    stdy_imvfl_email_address: false
  };
  const [validationObj, setValidationObj] = useState(initialMandatoryValidation);

  const isMandatoryFieldsSupplied = (): boolean => {
    const tempArr = [];
    let tempValidArray = validationObj;
    if (imvFollowUpData.visit_follow_up.stdy_imvfl_salutation_letter === '') {
      tempValidArray = { ...tempValidArray, stdy_imvfl_salutation_letter: true };
      tempArr.push(true);
    }
    if (imvFollowUpData.visit_follow_up.stdy_imvfl_next_visit_date === '') {
      tempValidArray = { ...tempValidArray, stdy_imvfl_next_visit_date: true };
      tempArr.push(true);
    }
    if (imvFollowUpData.visit_follow_up.stdy_imvfl_email_address === '' || email === '' || email === null) {
      tempValidArray = { ...tempValidArray, stdy_imvfl_email_address: true };
      tempArr.push(true);
    }
    if (
      imvFollowUpData.visit_follow_up.stdy_imvfl_phone_number_letter === '' ||
      (phoneNumberLetter && phoneNumberLetter[0] === '')
    ) {
      tempValidArray = { ...tempValidArray, stdy_imvfl_phone_number_letter: true };
      tempArr.push(true);
    }

    setValidationObj(tempValidArray);
    if (tempArr.length > 0) {
      return !tempArr.some(e => e);
    } else {
      return true;
    }
  };

  const validationOfRTE1 =
    imvFollowUpData?.visit_follow_up?.imvfl_rte1 === '' || imvFollowUpData?.visit_follow_up?.imvfl_rte1 === null
      ? StaticJson.IMVfollowupLetterRTE1
      : imvFollowUpData?.visit_follow_up?.imvfl_rte1;
  const validationOfRTE2 =
    imvFollowUpData?.visit_follow_up?.imvfl_rte2 === '' || imvFollowUpData?.visit_follow_up?.imvfl_rte2 === null
      ? StaticJson.IMVfollowupLetterRTE2
      : imvFollowUpData?.visit_follow_up?.imvfl_rte2;

  const handleFollowUpSave = () => {
    dispatch(showLoader());
    if (isMandatoryFieldsSupplied()) {
      if (isLetterCreated) {
        updateImvFollowUp({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          data: {
            visit_follow_up: {
              stdy_imvfl_salutation_letter: imvFollowUpData.visit_follow_up.stdy_imvfl_salutation_letter.trim(),
              stdy_imvfl_phone_number_letter: imvFollowUpData.visit_follow_up.stdy_imvfl_phone_number_letter,
              stdy_imvfl_email_address: imvFollowUpData.visit_follow_up.stdy_imvfl_email_address,
              stdy_imvfl_cra_first_name: userFullName,
              stdy_imvfl_name_sponsor: imvFollowUpData.visit_follow_up.stdy_imvfl_name_sponsor,
              stdy_imvfl_publish_version: imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version,
              stdy_imvfl_next_visit_date: imvFollowUpData.visit_follow_up.stdy_imvfl_next_visit_date,
              stdy_imvfl_review_items: imvFollowUpData.visit_follow_up.stdy_imvfl_review_items,
              tp_document_meta_id: imvFollowUpData.visit_follow_up.tp_document_meta_id,
              tp_document_id: imvFollowUpData.visit_follow_up.tp_document_id,
              monitoring_visit_id: imvFollowUpData.visit_follow_up.monitoring_visit_id,
              is_published: false,
              imvfl_rte1: htmlContent1 === '' ? validationOfRTE1 : htmlContent1,
              imvfl_rte2: htmlContent2 === '' ? validationOfRTE2 : htmlContent2,
              id: imvFollowUpData.visit_follow_up.id,
              stdy_imvfl_visit_issue: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_issue,
              stdy_imvfl_visit_start_date: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_start_date,
              stdy_imvfl_visit_end_date: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_end_date,
              stdy_imvfl_visit_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_protocol_deviation,
              stdy_imvfl_visit_start_date_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_start_date_protocol_deviation,
              stdy_imvfl_visit_end_date_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_end_date_protocol_deviation
            },
            protocol_deviations: imvFollowUpData.protocol_deviations,
            issues: imvFollowUpData.issues,
            updated_by: userFullName
          }
        });
      } else {
        createImvFollowUp({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          data: {
            visit_follow_up: {
              stdy_imvfl_salutation_letter: imvFollowUpData.visit_follow_up.stdy_imvfl_salutation_letter,
              stdy_imvfl_phone_number_letter:
                imvFollowUpData.visit_follow_up.stdy_imvfl_phone_number_letter === ''
                  ? phoneNumberLetter
                    ? phoneNumberLetter[0]
                    : ''
                  : imvFollowUpData.visit_follow_up.stdy_imvfl_phone_number_letter,
              stdy_imvfl_email_address:
                imvFollowUpData.visit_follow_up.stdy_imvfl_email_address === ''
                  ? email
                  : imvFollowUpData.visit_follow_up.stdy_imvfl_email_address,
              stdy_imvfl_cra_first_name: imvFollowUpData.visit_follow_up.stdy_imvfl_cra_first_name,
              stdy_imvfl_name_sponsor: sponsor,
              stdy_imvfl_publish_version: 0,
              stdy_imvfl_next_visit_date: imvFollowUpData.visit_follow_up.stdy_imvfl_next_visit_date,
              stdy_imvfl_review_items: imvFollowUpData.visit_follow_up.stdy_imvfl_review_items,
              is_published: false,
              imvfl_rte1: htmlContent1 === '' ? validationOfRTE1 : htmlContent1,
              imvfl_rte2: htmlContent2 === '' ? validationOfRTE2 : htmlContent2,
              monitoring_visit_id: props.letterData.id,
              stdy_imvfl_visit_issue: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_issue,
              stdy_imvfl_visit_start_date: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_start_date,
              stdy_imvfl_visit_end_date: imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_end_date,
              stdy_imvfl_visit_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_protocol_deviation,
              stdy_imvfl_visit_start_date_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_start_date_protocol_deviation,
              stdy_imvfl_visit_end_date_protocol_deviation:
                imvFollowUpData?.visit_follow_up?.stdy_imvfl_visit_end_date_protocol_deviation
            },
            protocol_deviations: imvFollowUpData.protocol_deviations,
            issues: imvFollowUpData.issues,
            created_by: userFullName
          }
        });
      }
    }
    dispatch(hideLoader());
  };

  const isUpdatePublish = imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version ? true : false;

  async function publishToEtmf() {
    dispatch(showLoader());
    let version = 0;
    if (isUpdatePublish) {
      version = Math.floor(imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version + 1);
    } else {
      version = 1;
    }
    await publishImvFollowUpData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      publish_doc_version: version,
      monitoring_visit_id: props.letterData.id,
      update: isUpdatePublish,
      is_published: true,
      time_zone_id: UI_TIME_ZONE,
      application: process.env.REACT_APP_NAME
    });
    setConfirmExitValue(dispatch, false);
    getIndividualFollowUp();
    setDisableEditContent1(true);
    setDisableEditContent2(true);
    dispatch(hideLoader());
  }

  const printImvFollowupLetter = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: props.letterData.id,
        template_name: 'Interim_Monitoring_Visit_Follow-up_Letter',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          country: selectedCountry,
          appName: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : 'TSDA',
          time_zone_id: UI_TIME_ZONE
        }
      };
      let pdfOptions: any = {};
      if (imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version) {
        pdfOptions = {
          ...options,
          pathVariables: {
            version: imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version.toFixed(1),
            ...options.pathVariables
          }
        };
      } else {
        pdfOptions = options;
      }
      const printViewerApiString = imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version
        ? 'get_imvChecklist_pdf_file_version'
        : 'get_imvChecklist_pdf_file';
      printPdfWithViewer(printViewerApiString, pdfOptions, 'application/pdf');

      setTimeout(function () {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };

  const getServerDateOrInvalid = (newDateValue: any) => {
    return String(newDateValue.$d) !== 'Invalid Date'
      ? moment(newDateValue.$d).format(SERVER_DATE_FORMAT)
      : String(newDateValue.$d);
  };

  const handleClickOpenImport = (log: string) => {
    setOpenImport(true);
    setLogType(log);
    setIMVFollowUpData({
      ...imvFollowUpData,
      visit_follow_up: {
        ...imvFollowUpData.visit_follow_up,
        stdy_imvfl_visit_issue: props.letterData.visit_name,
        stdy_imvfl_visit_protocol_deviation: props.letterData.visit_name
      }
    });
    setConfirmExitValue(dispatch, true);
  };

  const handleCloseImport = () => {
    setOpenImport(false);
    setIMVFLdetailsError({
      stdy_imvfl_visit_start_date: null,
      stdy_imvfl_visit_end_date: null,
      stdy_imvfl_visit_start_date_protocol_deviation: null,
      stdy_imvfl_visit_end_date_protocol_deviation: null
    });
  };

  const handleImportSubmit = async () => {
    props.setIsChanged(true);
    if (logType === 'issues') {
      if (
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date !== 'Invalid Date' &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date !== 'Invalid Date' &&
        (imvFLdetailsError.stdy_imvfl_visit_start_date == false ||
          imvFLdetailsError.stdy_imvfl_visit_end_date == false) &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date != null &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date != null &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date != '' &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date != ''
      ) {
        const filteredIssues: any = await getIssueLogBasedOnDateRange({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          issue_level: 'SPONSOR',
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          start_date: imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date,
          end_date: imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date
        });
        if (
          filteredIssues?.isSuccess &&
          filteredIssues?.data?.selected_data &&
          filteredIssues?.data?.selected_data.length > 0
        ) {
          const modifiedIssues: any = filteredIssues?.data.selected_data.map((ele: any) => {
            return {
              id: ele.issue_details?.id,
              stdy_imvfl_subject_id: ele.issue_details?.subject_id,
              stdy_imvfl_issue_class: ele.issue_details?.issue_class,
              stdy_imvfl_issues: ele.issue_details?.issue,
              stdy_imvfl_category: ele.issue_details?.category,
              stdy_imvfl_action_description: ele.issue_details?.action_des,
              stdy_imvfl_action_due_date: ele.issue_details?.action_due
            };
          });
          setIMVFollowUpData({ ...imvFollowUpData, issues: modifiedIssues });
          setConfirmExitValue(dispatch, true);
        } else {
          setIMVFollowUpData({ ...imvFollowUpData, issues: [] });
          dispatch(setMessage({ msgDetails: 'No Issues', severity: 'error' }));
        }
        setOpenImport(false);
      } else {
        let imvFLdetailsErrorModified = { ...imvFLdetailsError };
        if (
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date == null ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date === 'Invalid Date' ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date == ''
        ) {
          imvFLdetailsErrorModified = { ...imvFLdetailsErrorModified, stdy_imvfl_visit_start_date: true };
        }
        if (
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date == null ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date === 'Invalid Date' ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date === ''
        ) {
          imvFLdetailsErrorModified = { ...imvFLdetailsErrorModified, stdy_imvfl_visit_end_date: true };
        }

        setIMVFLdetailsError({ ...imvFLdetailsError, ...imvFLdetailsErrorModified });
        dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
      }
    } else {
      if (
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation !== 'Invalid Date' &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation !== 'Invalid Date' &&
        (imvFLdetailsError.stdy_imvfl_visit_start_date_protocol_deviation == false ||
          imvFLdetailsError.stdy_imvfl_visit_end_date_protocol_deviation == false) &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation != null &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation != null &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation != '' &&
        imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation != ''
      ) {
        const filteredProtocolDeviation: any = await getProtocolDeviationLogBasedOnDateRange({
          deviation_level: 'SPONSOR',
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          start_date: imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation,
          end_date: imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation
        });
        if (
          filteredProtocolDeviation?.isSuccess &&
          filteredProtocolDeviation?.data?.selected_data &&
          filteredProtocolDeviation?.data?.selected_data.length > 0
        ) {
          const modifiedProtocolDeviation: any = filteredProtocolDeviation?.data?.selected_data.map((ele: any) => {
            return {
              id: ele.deviation_details?.id,
              stdy_imvfl_subject_id: ele.deviation_details.subject_id,
              stdy_imvfl_protocol_deviation_description: ele.deviation_details.deviation_des,
              stdy_imvfl_category: ele.deviation_details.category,
              stdy_imvfl_action_description: ele.deviation_details.action_des,
              stdy_imvfl_action_due_date: ele.deviation_details.action_due
            };
          });
          setIMVFollowUpData({ ...imvFollowUpData, protocol_deviations: modifiedProtocolDeviation });
          setConfirmExitValue(dispatch, true);
        } else {
          dispatch(setMessage({ msgDetails: 'No Protocol Devation', severity: 'error' }));
          setIMVFollowUpData({ ...imvFollowUpData, protocol_deviations: [] });
        }
        setOpenImport(false);
      } else {
        let imvFLdetailsErrorModified = { ...imvFLdetailsError };
        if (
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation == null ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation === 'Invalid Date' ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation === ''
        ) {
          imvFLdetailsErrorModified = {
            ...imvFLdetailsErrorModified,
            stdy_imvfl_visit_start_date_protocol_deviation: true
          };
        }
        if (
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation == null ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation === 'Invalid Date' ||
          imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation === ''
        ) {
          imvFLdetailsErrorModified = {
            ...imvFLdetailsErrorModified,
            stdy_imvfl_visit_end_date_protocol_deviation: true
          };
        }
        setIMVFLdetailsError({ ...imvFLdetailsError, ...imvFLdetailsErrorModified });
        dispatch(setMessage({ msgDetails: 'Mandatory information is missing', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    setReviewCodelistItems(props.originalReviewedItems);
    getIndividualFollowUp();
  }, []);

  useEffect(() => {
    if (createImvFollowUpIsSuccess || updateImvFollowUpIsSuccess) {
      getIndividualFollowUp();
      setIsLetterCreated(true);
      props.setIsChanged(false);
      setValidationObj(initialMandatoryValidation);
      setConfirmExitValue(dispatch, false);
      dispatch(
        setMessage({
          msgDetails: 'Data saved successfully',
          severity: 'success'
        })
      );
      getIndividualFollowUp();
      setOpenRTEContent1(false);
      setOpenRTEContent2(false);
      setDisableEditContent1(false);
      setDisableEditContent2(false);
      props.setIsChanged(false);
    }
  }, [createImvFollowUpIsSuccess, updateImvFollowUpIsSuccess]);
  useEffect(() => {
    if (createImvFollowUpIsError || updateImvFollowUpIsError) {
      dispatch(
        setMessage({
          msgDetails: 'Error while saving follow-up letter',
          severity: 'error'
        })
      );
    }
  }, [createImvFollowUpIsError, updateImvFollowUpIsError]);

  useEffect(() => {
    if (publishImvFollowUpIsSuccess) {
      setConfirmExitValue(dispatch, false);
      dispatch(
        setMessage({ msgDetails: 'Monitoring Visit followup Letter published to eTMF repository', severity: 'success' })
      );
    } else if (publishImvFollowUpError) {
      dispatch(
        setMessage({ msgDetails: 'Monitoring Visit followup Letter publish is getting Error', severity: 'error' })
      );
    }
  }, [publishImvFollowUpIsSuccess, publishImvFollowUpError]);

  useEffect(() => {
    if (selectedSite === null || isHierarchyLevelClosed) {
      props.handleBack(props.isChanged);
    }
  }, [studyId, selectedCountry, selectedSite, isHierarchyLevelClosed]);

  const handelChangeTextEditor = (htmlContext: any, planetext: any, e: any) => {
    e === 'IMVfollowupLetterRTE1' ? setHtmlContent1(htmlContext) : setHtmlContent2(htmlContext);
  };
  const handleEditRTE = (content: string) => {
    switch (content) {
      case 'content1':
        setOpenRTE1(true);
        setOpenRTEContent1(true);
        break;
      case 'content2':
        setOpenRTE2(true);
        setOpenRTEContent2(true);
        break;
    }
  };
  const handleSaveRTE = (content: string) => {
    switch (content) {
      case 'content1':
        setOpenRTE1(false);
        setDisableEditContent1(true);
        props.setIsChanged(true);
        break;
      case 'content2':
        setOpenRTE2(false);
        setDisableEditContent2(true);
        props.setIsChanged(true);
        break;
    }
  };

  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {props.letterData.visit_name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' && (
              <Button
                onClick={publishToEtmf}
                variant="contained"
                style={{ textTransform: 'none' }}
                sx={{ alignSelf: 'center' }}
                disabled={!publishFULetterPermission || imvFollowUpData.visit_follow_up.is_published}
              >
                PUBLISH TO eTMF
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                onClick={handleFollowUpSave}
                disabled={
                  !updateFULetterPermission ||
                  !props.isChanged ||
                  !imvFollowUpData.visit_follow_up.stdy_imvfl_salutation_letter
                }
              >
                Save
              </Button>
            )}
            <IconButton
              aria-label="Print"
              color="primary"
              sx={{ alignSelf: 'center' }}
              onClick={printImvFollowupLetter}
              disabled={
                imvFollowUpData.visit_follow_up.stdy_imvfl_publish_version == 0 ||
                !imvFollowUpData.visit_follow_up.is_published
              }
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage" component="form" noValidate autoComplete="off">
        {props.siteStudyPersonnelsData && (
          <Typography gutterBottom color="text.secondary2">
            {getPreferredDateInLocal(props.letterData.start_date)} <br />
            {props.siteStudyPersonnelsData?.site?.pi_first_name} {props.siteStudyPersonnelsData?.site?.pi_last_name}{' '}
            <br />
            {props.siteStudyPersonnelsData?.site?.site_name} <br />
            {props.siteStudyPersonnelsData?.site?.site_street_address1}
            {props.siteStudyPersonnelsData?.site?.site_street_address2 !== null
              ? `, ${props.siteStudyPersonnelsData?.site?.site_street_address2}`
              : ''}{' '}
            <br />
            {props.siteStudyPersonnelsData?.site?.site_city}
            {props.siteStudyPersonnelsData?.site?.site_state !== null
              ? `, ${props.siteStudyPersonnelsData?.site?.site_state}`
              : ''}
            {props.siteStudyPersonnelsData?.site?.site_zip_code !== null
              ? `, ${props.siteStudyPersonnelsData?.site?.site_zip_code}`
              : ''}
          </Typography>
        )}

        <dl className="text-Bold dlStyle">
          <dt>RE:</dt>
          <dd>
            {props.siteStudyPersonnelsData?.study?.study_id}-{props.siteStudyPersonnelsData?.study?.study_title} <br />
            Interim Monitoring Visit for Protocol {props.siteStudyPersonnelsData?.study?.study_id}
            <br />
            Site Number: {props.siteStudyPersonnelsData?.site?.site_id}
          </dd>
        </dl>

        <Typography sx={{ mb: 1, pt: 2 }}>
          <b>Dear</b> &nbsp;{' '}
          <span style={{ width: '180px', display: 'inline-block' }}>
            <TextField
              id="standard-error-helper-text"
              label="Salutation"
              required
              variant="standard"
              name="stdy_imvfl_salutation_letter"
              className="titleField"
              inputProps={{ maxLength: 50 }}
              value={imvFollowUpData.visit_follow_up.stdy_imvfl_salutation_letter?.trimStart()}
              onChange={e => handleChange(e)}
              error={validationObj.stdy_imvfl_salutation_letter}
              disabled={!updateFULetterPermission}
              helperText={validationObj.stdy_imvfl_salutation_letter && 'Required'}
              sx={{ mt: '-16px !important' }}
            />
          </span>
          <b>
            &nbsp; {props.siteStudyPersonnelsData?.site?.pi_first_name}{' '}
            {props.siteStudyPersonnelsData?.site?.pi_last_name},
          </b>{' '}
          <br />
        </Typography>
        <Typography gutterBottom>
          I would like to thank you for your time during the Interim Monitoring visit conducted on{' '}
          {getPreferredDateInLocal(props.letterData.start_date)} for the above-named study.
        </Typography>
        {contentEditPermission ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE1 ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content1')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent1}
                  onClick={() => handleEditRTE('content1')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent1 ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) =>
                    handelChangeTextEditor(htmlContext, planetext, 'IMVfollowupLetterRTE1')
                  }
                  value={validationOfRTE1}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent1}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE1
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE1
            }}
          />
        )}
        <Typography gutterBottom>
          <ul style={{ marginLeft: '-20px' }} className="listWitCloseicon">
            {reviewedItems.length > 0 &&
              reviewedItems.map((reviewItem: string, index: number) => (
                <li key={index}>
                  {reviewItem}
                  <IconButton
                    size="small"
                    aria-label="close"
                    onClick={() => onReviewItemClose(reviewItem, index)}
                    className="rightClose"
                  >
                    <CloseIcon />
                  </IconButton>
                </li>
              ))}
          </ul>
        </Typography>

        <Typography gutterBottom>The protocol deviations that were noted during this visit include:</Typography>
        <TableContainer>
          <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Subject ID</b>
                </TableCell>
                <TableCell>
                  <b>Protocol Deviation Description</b>
                </TableCell>
                <TableCell>
                  <b>Category</b>
                </TableCell>
                <TableCell>
                  <b>Action Description</b>
                </TableCell>
                <TableCell>
                  <b>Action Due Date</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {imvFollowUpData.protocol_deviations.length ? (
                imvFollowUpData.protocol_deviations.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.stdy_imvfl_subject_id}</TableCell>
                    <TableCell>{row.stdy_imvfl_protocol_deviation_description}</TableCell>
                    <TableCell>{row.stdy_imvfl_category}</TableCell>
                    <TableCell>{row.stdy_imvfl_action_description}</TableCell>
                    <TableCell>
                      {row.stdy_imvfl_action_due_date &&
                        moment(row.stdy_imvfl_action_due_date).format(userPreferedDateFormat.toUpperCase())}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow key={1}>
                  <TableCell colSpan={5}>No protocol deviations found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          variant="contained"
          sx={{ mt: 1, mb: 3 }}
          onClick={() => handleClickOpenImport('protocolDeviation')}
          disabled={!updateFULetterPermission}
        >
          Import
        </Button>

        <Typography gutterBottom>
          At the end of the monitoring visit, the following was discussed with you and your staff to correct
          deficiencies noted:
        </Typography>
        <TableContainer>
          <Table aria-label="collapsible table" className="table table-bordered table-column-bordered">
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Subject ID</b>
                </TableCell>
                <TableCell>
                  <b>Category</b>
                </TableCell>
                <TableCell>
                  <b>Issue Class</b>
                </TableCell>
                <TableCell>
                  <b>Issue</b>
                </TableCell>
                <TableCell>
                  <b>Action Description</b>
                </TableCell>
                <TableCell>
                  <b>Action Due Date</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {imvFollowUpData.issues.length ? (
                imvFollowUpData.issues.map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.stdy_imvfl_subject_id}</TableCell>
                    <TableCell>{row.stdy_imvfl_category}</TableCell>
                    <TableCell>{row.stdy_imvfl_issue_class}</TableCell>
                    <TableCell>{row.stdy_imvfl_issues}</TableCell>
                    <TableCell>{row.stdy_imvfl_action_description}</TableCell>
                    <TableCell>
                      {row.stdy_imvfl_action_due_date &&
                        moment(row.stdy_imvfl_action_due_date).format(userPreferedDateFormat.toUpperCase())}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow key={1}>
                  <TableCell colSpan={6}>No issues found</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Button
          variant="contained"
          sx={{ mt: 1, mb: 3 }}
          onClick={() => handleClickOpenImport('issues')}
          disabled={!updateFULetterPermission}
        >
          Import
        </Button>

        {contentEditPermission ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE2 ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content2')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent2}
                  onClick={() => handleEditRTE('content2')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent2 ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) =>
                    handelChangeTextEditor(htmlContext, planetext, 'IMVfollowupLetterRTE2')
                  }
                  value={validationOfRTE2}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent2}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE2
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE2
            }}
          />
        )}

        <Typography gutterBottom>
          The next monitoring visit is schedule for{' '}
          <span style={{ width: '180px', display: 'inline-block', paddingRight: '4px', marginLeft: '4px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <DatePicker
                  label="Date"
                  inputFormat={userPreferedDateFormat.toUpperCase()}
                  value={imvFollowUpData.visit_follow_up.stdy_imvfl_next_visit_date}
                  onChange={(newValue: any) => {
                    let nextVisitDate = '';
                    if (newValue != null) {
                      const changedDate = getServerDateOrInvalidDayJs(newValue);
                      if (changedDate !== 'Invalid Date' && changedDate.length === 10) {
                        nextVisitDate = changedDate;
                      }
                    }
                    props.setIsChanged(true);
                    setIMVFollowUpData({
                      ...imvFollowUpData,
                      visit_follow_up: {
                        ...imvFollowUpData.visit_follow_up,
                        stdy_imvfl_next_visit_date: nextVisitDate
                      }
                    });
                    setValidationObj({ ...validationObj, stdy_imvfl_next_visit_date: false });
                  }}
                  renderInput={(params: any) => {
                    return (
                      <TextField
                        {...params}
                        required
                        error={validationObj.stdy_imvfl_next_visit_date}
                        helperText={validationObj.stdy_imvfl_next_visit_date && 'Required'}
                        variant="standard"
                        size="small"
                        sx={{ width: '20%', mt: -2 }}
                      />
                    );
                  }}
                  disabled={!updateFULetterPermission}
                />
              </Stack>
            </LocalizationProvider>
          </span>
          .
        </Typography>
        <Typography gutterBottom>
          In the interim, should you have any questions, Please do not hesitate to contact me at{' '}
          <span style={{ width: '180px', display: 'inline-block', margin: '0 4px' }}>
            <TextField
              id="standard-error-helper-text"
              label="Phone number"
              required
              variant="standard"
              name="stdy_imvfl_phone_number_letter"
              value={imvFollowUpData.visit_follow_up.stdy_imvfl_phone_number_letter || ''}
              onChange={e => handleChange(e)}
              error={validationObj.stdy_imvfl_phone_number_letter}
              sx={{ mt: '-16px !important' }}
              inputProps={{ maxLength: 15 }}
              disabled={!updateFULetterPermission}
              helperText={validationObj.stdy_imvfl_phone_number_letter && 'Required'}
              size="small"
            />{' '}
          </span>
          &nbsp; or &nbsp;
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="standard-error-helper-text"
              label="Email"
              required
              variant="standard"
              name="stdy_imvfl_email_address"
              value={imvFollowUpData.visit_follow_up.stdy_imvfl_email_address}
              onChange={e => handleChange(e)}
              error={validationObj.stdy_imvfl_email_address}
              sx={{ mt: '-8px !important' }}
              inputProps={{ maxLength: 50 }}
              disabled={!updateFULetterPermission}
              helperText={validationObj.stdy_imvfl_email_address && 'Required'}
              size="small"
            />
          </span>
        </Typography>

        <Typography gutterBottom>
          {`Thank you again for your staff’s time and assistance during this visit.`}
        </Typography>

        <Typography gutterBottom>
          Yours sincerely, <br />
          {imvFollowUpData.visit_follow_up.stdy_imvfl_cra_first_name} <br />
          <span color="text.secondary">{sponsor?.toUpperCase()}</span>
        </Typography>
      </Box>
      <PopupComponent
        open={props.openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              props.setOpenConfirmExit(false);
              props.setOpenFollowupLetter(false);
              props.setViewIMVFollowUpGrid(true);
              setConfirmExitPopupVal(dispatch, false);
              props.setIsChanged(false);
              props.handleBack(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      <Confirm
        isOpen={openConfirmRemove}
        message="Are you sure you want to remove?"
        onCancel={() => setOpenConfirmRemove(false)}
        onConfirm={() => {
          handleReviewItemClose();
        }}
        className="defaultModal"
        btnClassName="grey-btn"
      />
      <PopupComponent open={openImport} sx={{ '@media (max-width:1367px)': { marginTop: '-136px' } }}>
        <DialogTitle id="alert-dialog-title">{'Import'}</DialogTitle>
        <DialogContent sx={{ minWidth: '600px' }}>
          <Grid container spacing={2} className="event-form">
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel
                  required
                  id="selectVisit"
                  sx={{
                    '&[data-shrink="false"]': { transform: 'translate(0, 16px) scale(1)' },
                    '&[data-shrink="true"]': { transform: 'translate(0, -9px) scale(0.75)' }
                  }}
                >
                  Visit
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Visit"
                  defaultValue={'10'}
                  onChange={handleChange}
                >
                  <MenuItem value={'10'}>{props.letterData?.visit_name}</MenuItem>
                </Select>
              </FormControl>

              <Grid />
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    inputFormat={dateFormat}
                    label="Start Date"
                    value={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date)
                        : preferedFormatForDatePicker(
                            imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation
                          )
                    }
                    maxDate={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date)
                        : preferedFormatForDatePicker(
                            imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation
                          )
                    }
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        logType === 'issues'
                          ? setIMVFollowUpData({
                              ...imvFollowUpData,
                              visit_follow_up: {
                                ...imvFollowUpData.visit_follow_up,
                                stdy_imvfl_visit_start_date: getServerDateOrInvalid(newValue)
                              }
                            })
                          : setIMVFollowUpData({
                              ...imvFollowUpData,
                              visit_follow_up: {
                                ...imvFollowUpData.visit_follow_up,
                                stdy_imvfl_visit_start_date_protocol_deviation: getServerDateOrInvalid(newValue)
                              }
                            });
                        setIMVFLdetailsError({
                          ...imvFLdetailsError,
                          stdy_imvfl_visit_start_date: false,
                          stdy_imvfl_visit_start_date_protocol_deviation: false
                        });
                      } else {
                        setIMVFLdetailsError({
                          ...imvFLdetailsError,
                          stdy_imvfl_visit_start_date: true,
                          stdy_imvfl_visit_start_date_protocol_deviation: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        required
                        error={
                          imvFLdetailsError.stdy_imvfl_visit_start_date ||
                          imvFLdetailsError.stdy_imvfl_visit_start_date_protocol_deviation
                        }
                        helperText={
                          imvFLdetailsError.stdy_imvfl_visit_start_date ||
                          imvFLdetailsError.stdy_imvfl_visit_start_date_protocol_deviation
                            ? 'Required'
                            : ''
                        }
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                variant="standard"
                className="custom-datePicker"
                fullWidth
              >
                <FormControl fullWidth>
                  <DesktopDatePicker
                    //disableFuture
                    inputFormat={dateFormat}
                    label="End Date"
                    value={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date)
                        : preferedFormatForDatePicker(
                            imvFollowUpData.visit_follow_up.stdy_imvfl_visit_end_date_protocol_deviation
                          )
                    }
                    minDate={
                      logType === 'issues'
                        ? preferedFormatForDatePicker(imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date)
                        : preferedFormatForDatePicker(
                            imvFollowUpData.visit_follow_up.stdy_imvfl_visit_start_date_protocol_deviation
                          )
                    }
                    onChange={(newValue: any) => {
                      if (newValue != null) {
                        logType === 'issues'
                          ? setIMVFollowUpData({
                              ...imvFollowUpData,
                              visit_follow_up: {
                                ...imvFollowUpData.visit_follow_up,
                                stdy_imvfl_visit_end_date: getServerDateOrInvalid(newValue)
                              }
                            })
                          : setIMVFollowUpData({
                              ...imvFollowUpData,
                              visit_follow_up: {
                                ...imvFollowUpData.visit_follow_up,
                                stdy_imvfl_visit_end_date_protocol_deviation: getServerDateOrInvalid(newValue)
                              }
                            });
                        setIMVFLdetailsError({
                          ...imvFLdetailsError,
                          stdy_imvfl_visit_end_date: false,
                          stdy_imvfl_visit_end_date_protocol_deviation: false
                        });
                      } else {
                        setIMVFLdetailsError({
                          ...imvFLdetailsError,
                          stdy_imvfl_visit_end_date: true,
                          stdy_imvfl_visit_end_date_protocol_deviation: true
                        });
                      }
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        required
                        error={
                          imvFLdetailsError.stdy_imvfl_visit_end_date ||
                          imvFLdetailsError.stdy_imvfl_visit_end_date_protocol_deviation
                        }
                        helperText={
                          imvFLdetailsError.stdy_imvfl_visit_end_date ||
                          imvFLdetailsError.stdy_imvfl_visit_end_date_protocol_deviation
                            ? 'Required'
                            : ''
                        }
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImport} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleImportSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};

export default IMVFollowupLetter;
